import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

import { Client, RegionDataIn } from '../../../../../api/api-reference';

@Component({
  selector: 'app-region-setup',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, AngularSvgIconModule],
  templateUrl: './region-setup.component.html',
  styleUrl: './region-setup.component.scss',
})
export class RegionSetupComponent implements OnInit {
  @Input() selectedRegion: string | null = null;
  @Output() close = new EventEmitter<boolean>();
  data: RegionDataIn = new RegionDataIn();

  @ViewChild('crudform') crudform!: NgForm;
  constructor(
    private client: Client,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.getRegion();
  }

  toggleModal(reaload?: boolean) {
    this.close.emit(reaload);
  }

  getRegion() {
    if (this.selectedRegion) {
      this.client.getRegion(this.selectedRegion).subscribe({
        next: (response) => {
          this.data.id = response.id;
          this.data.name = response.name ?? '';
          this.data.code = response.code ?? '';
        },
        error: (err) => {
          this.toastr.error(err);
        },
      });
    }
  }

  onSubmit() {
    this.client.saveRegion(this.data).subscribe({
      next: (response) => {
        this.toastr.success(response);
        this.toggleModal(true);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }
}
